import { render, staticRenderFns } from "./FoundedProperty.vue?vue&type=template&id=2075b025&scoped=true&"
import script from "./FoundedProperty.vue?vue&type=script&lang=js&"
export * from "./FoundedProperty.vue?vue&type=script&lang=js&"
import style0 from "./FoundedProperty.vue?vue&type=style&index=0&id=2075b025&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2075b025",
  null
  
)

export default component.exports